import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@/components/Modal";
import { ColorPicker } from "@/components/ColorPicker";
import { Palette } from "lucide-react";

export interface ColorPickerModalProps {
    value: string;
    onChange: (hexColor: string) => void;
    label?: string;
    isSelected?: boolean;
}

export const ColorPickerModal: React.FC<ColorPickerModalProps> = ({
    value,
    onChange,
    label,
    isSelected = false,
}) => {
    const { t } = useTranslation("global");
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [tempValue, setTempValue] = useState<string>(value || "#FF0086");

    const handleApply = () => {
        onChange(tempValue);
        setIsModalOpen(false);
    };

    const handleOpen = () => {
        setTempValue(value || "#FF0086");
        setIsModalOpen(true);
    };

    return (
        <>
            <button
                type="button"
                onClick={handleOpen}
                style={{
                    backgroundColor: value?.startsWith("#") ? value : "#FF0086",
                }}
                className={`w-9 h-9 sm:w-10 sm:h-10 rounded-full transition-all cursor-pointer shadow-xs flex items-center justify-center relative group border border-black/10 dark:border-white/10 shrink-0 ${
                    isSelected
                        ? "ring-2 ring-offset-1 ring-primary dark:ring-offset-zinc-900 scale-105 opacity-100"
                        : "opacity-75 hover:opacity-100 hover:scale-105"
                }`}
                title={t("color_picker.choose_color")}
            >
                <Palette className="w-5 h-5 text-white drop-shadow-xs group-hover:scale-110 transition-transform" />
            </button>

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={label || t("color_picker.title")}
                maxWidth="md"
                onSubmit={handleApply}
                submitLabel={t("color_picker.apply")}
                cancelLabel={t("color_picker.cancel")}
            >
                <ColorPicker value={tempValue} onChange={setTempValue} />
            </Modal>
        </>
    );
};

export default ColorPickerModal;
